<template>
    <div class="pc-container">
        <!-- <div class="container-header">
            <Header />
        </div> -->
        <div class="container-main">
            <router-view />
        </div>
    </div>
</template>


<script>
export default {
    name: "Home",
    components: {
    },
};
</script>

<style lang="less" scoped>
    .pc-container {
        width: 100%;
        height: 100%;
        min-width: 1080px;
        .container-header {
            position: sticky;
            z-index: 1001;
            top: 0;
            margin: 0 auto;
            background-color: #fff;
        }
    }
</style>
